export default {
      ProductYears: '$MHF_ModelNameVal_$MHF|ProductYears',

};
